export default __webpack_public_path__ + "static/media/logo-text2.d23fddf4.png";